export default {
    name: 'v5-icon-warn-fill',
    render: function (h) {
        return h('svg', {
            attrs: {
                class: 'icon',
                height: '32',
                viewBox: '0 0 1024 1024',
                width: '32',
                xmlns: 'http://www.w3.org/2000/svg'
            }
        }, [
            h('path', {
                attrs: {
                    d: 'M512 85.333c235.637 0 426.667 191.03 426.667 426.667S747.637 938.667 512 938.667 85.333 747.637 85.333 512 276.363 85.333 512 85.333zm0 544a42.667 42.667 0 100 85.334 42.667 42.667 0 000-85.334zm0-362.666a42.667 42.667 0 00-42.667 42.666V544a42.667 42.667 0 1085.334 0V309.333A42.667 42.667 0 00512 266.667z',
                    fill: 'currentColor'
                }
            })
        ]);
    }
};
